import CaseStudyEightContainer from "./containers/CaseStudyEightContainer";
export default CaseStudyEightContainer;
